import { render, staticRenderFns } from "./plaingold.vue?vue&type=template&id=dd650a00&scoped=true"
import script from "./plaingold.vue?vue&type=script&lang=js"
export * from "./plaingold.vue?vue&type=script&lang=js"
import style0 from "./plaingold.vue?vue&type=style&index=0&id=dd650a00&prod&lang=scss&scoped=true"
import style1 from "./plaingold.vue?vue&type=style&index=1&id=dd650a00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd650a00",
  null
  
)

export default component.exports